import { render } from "./ProductSummaryCard.vue?vue&type=template&id=23622e3e&scoped=true&ts=true"
import script from "./ProductSummaryCard.vue?vue&type=script&lang=ts"
export * from "./ProductSummaryCard.vue?vue&type=script&lang=ts"

import "./ProductSummaryCard.vue?vue&type=style&index=0&id=23622e3e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23622e3e"]])

export default __exports__